// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__3wsz_","point":"Summary_point__J2PZP","score":"Summary_score__9cm3j","badge":"Summary_badge__r2f87"};